import { Controller } from "@hotwired/stimulus"

// Automatically submits the form when an input changes.
// Attach to the form element with data-controller="auto-submit"
// and data-action="change->auto-submit#submit" on the input.
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
